module.exports = __webpack_public_path__ + "img/空白（版心宽+动静态文字）.57d4d4b1.jpg";